import React, { useEffect } from "react";
import { IntlProvider } from "react-intl"
import { ChakraProvider, extendTheme } from "@chakra-ui/react"
import useTranslation from "../hooks/useTranslation";
import useThemes from "../hooks/useThemes";
const Wrapper = ({ children }) => {
  const { locale, translation, fetchTranslation } = useTranslation()
  const { theme, fetchTheme } = useThemes()

  useEffect(() => {
    //Locale translations
    fetchTranslation()
    fetchTheme()
  }, [])

  const final_theme = extendTheme({
    ...theme, 
    styles: {
      global: {
        body: {
          fontFamily: null,
          lineHeight: null,
          fontSize: null,
          fontColor: null,
          fontWeight: null,
        }
      }
    }
  })
  return <ChakraProvider theme={final_theme} >
    <IntlProvider
      defaultLocale="en"
      locale={locale}
      key={translation}
      messages={translation}>
      {children}
    </IntlProvider>
  </ChakraProvider>
}

export default Wrapper;